module.exports = __webpack_public_path__ + "img/logo-culture-diagnostics.84a72011.png";